import React from 'react'
import { StyleSheet, View } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { Skeleton } from './Skeleton'
import { useScreen } from '@hooks'

const AVATAR_SIZE = 96

export const ProfileSkeleton: React.FC = () => {
  const theme = useTheme()
  const styles = getStyle(theme)
  const { isMobile } = useScreen()

  return (
    <View style={styles.container}>
      <View style={styles.infoContainer}>
        <Skeleton width={AVATAR_SIZE} height={AVATAR_SIZE} borderRadius={AVATAR_SIZE / 2} />
        <View style={styles.rightContainer}>
          <Skeleton width="55%" height={24} borderRadius={6} style={styles.nameSkeleton} />
          <Skeleton width="50%" height={16} borderRadius={4} style={styles.workSkeleton} />
          <View style={styles.row}>
            <Skeleton width={100} height={14} borderRadius={4} style={styles.locationSkeleton} />
            <Skeleton width={80} height={14} borderRadius={4} />
          </View>
        </View>
      </View>

      {/* Actions (Partager / Modifier) */}
      <View style={styles.actionsRow}>
        <Skeleton width="100%" height={44} borderRadius={22} style={styles.actionButton} />
        <Skeleton width="100%" height={44} borderRadius={22} style={styles.actionButton} />
      </View>

      {/* Tabs (À propos / À venir / Memories) */}
      <View style={styles.tabsRow}>
        <Skeleton width="100%" height={44} borderRadius={22} style={styles.tabPill} />
        <Skeleton width="100%" height={44} borderRadius={22} style={styles.tabPill} />
        <Skeleton width="100%" height={44} borderRadius={22} style={styles.tabPill} />
      </View>

      {/* Main content */}
      <View style={[styles.sectionsRow, isMobile && styles.sectionsRowMobile]}>
        <View style={styles.sectionCol}>
          <Skeleton width="55%" height={18} borderRadius={6} style={styles.sectionTitle} />
          <Skeleton width="100%" height={220} borderRadius={16} />
          <Skeleton width="45%" height={18} borderRadius={6} style={styles.sectionTitle} />
          <Skeleton width="100%" height={120} borderRadius={16} />
        </View>

        <View style={styles.sectionCol}>
          <Skeleton width="55%" height={18} borderRadius={6} style={styles.sectionTitle} />
          <Skeleton width="100%" height={160} borderRadius={16} />
          <Skeleton width="55%" height={18} borderRadius={6} style={styles.sectionTitle} />
          <Skeleton width="100%" height={210} borderRadius={16} />
        </View>

        <View style={styles.sectionCol}>
          <Skeleton width="55%" height={18} borderRadius={6} style={styles.sectionTitle} />
          <Skeleton width="100%" height={260} borderRadius={16} />
        </View>
      </View>
    </View>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flex: 1,
      paddingHorizontal: theme.spacing.lg,
      paddingVertical: theme.spacing.xxxl,
    },
    infoContainer: {
      flexDirection: 'row',
      alignItems: 'flex-end',
      gap: theme.spacing.md,
      marginBottom: theme.spacing.xl,
    },
    rightContainer: {
      flex: 1,
    },
    nameSkeleton: {
      marginBottom: theme.spacing.xs,
    },
    workSkeleton: {
      marginBottom: theme.spacing.xs,
    },
    row: {
      flexDirection: 'row',
      gap: theme.spacing.lg,
    },
    locationSkeleton: {
      marginRight: theme.spacing.md,
    },
    actionsRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing.md,
      marginBottom: theme.spacing.xl,
    },
    actionButton: {
      flex: 1,
    },
    tabsRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing.md,
      marginBottom: theme.spacing.xl,
    },
    tabPill: {
      flex: 1,
    },
    sectionsRow: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      gap: theme.spacing.lg,
    },
    sectionsRowMobile: {
      flexDirection: 'column',
    },
    sectionCol: {
      flex: 1,
      gap: theme.spacing.md,
    },
    sectionTitle: {
      marginTop: theme.spacing.xs,
    },
  })

